import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const BeworksBotIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <mask id="bot-eyes" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="white" />
      <circle cx="9.2" cy="13.5" r="1.3" fill="black" />
      <circle cx="14.8" cy="13.5" r="1.3" fill="black" />
    </mask>
    <g mask="url(#bot-eyes)">
      <rect x="5" y="8" width="14" height="11" rx="3" fill="currentColor" />
    </g>
    <path d="M12 8V5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="12" cy="4" r="1.2" fill="currentColor" />
  </SvgIcon>
);

export default BeworksBotIcon;
